import { buildSetupTradeLog } from './setupTradeLog'

const PAGE_SIZE = 500
const MAX_ROWS = 100000
const columns = {
  trades: '*',
  executions: 'id,user_id,trade_id,account_number,symbol,execution_type,side,quantity,price,commission,fees,executed_at,order_id,execution_id,schwab_activity_id,import_source',
  position_projects: 'id,user_id,symbol,direction,is_draft,setup_pattern,setup_type,setup_source,thesis,setup_notes,schwab_order_ids',
  account_nicknames: 'id,account_number,nickname',
}

/** Read every page or fail. A truncated history must never become performance. */
export async function loadOwnedRows(client, table, userId, signal) {
  if (!userId) throw new Error('Sign in to load trade history.')
  const rows = []
  let expected
  do {
    const { data, error, count } = await client.from(table)
      .select(columns[table], { count: 'exact' }).eq('user_id', userId)
      .order('id', { ascending: true }).range(rows.length, rows.length + PAGE_SIZE - 1)
      .abortSignal(signal)
    if (error || !Array.isArray(data) || !Number.isInteger(count)) {
      throw new Error('Trade history could not be loaded completely. Retry to refresh all records.')
    }
    if (expected != null && count !== expected) throw new Error('History changed while loading. Refresh to load it again.')
    expected = count
    if (expected > MAX_ROWS || (!data.length && rows.length < expected)) {
      throw new Error('Trade history is incomplete. No setup statistics are available.')
    }
    rows.push(...data)
  } while (rows.length < expected)
  if (rows.length !== expected || new Set(rows.map(row => row.id)).size !== rows.length) {
    throw new Error('History changed while loading. Refresh to load it again.')
  }
  return rows
}

export async function loadSetupTradeLog(client, userId, signal) {
  const [trades, executions, projects, nicknames] = await Promise.all(
    Object.keys(columns).map(table => loadOwnedRows(client, table, userId, signal)),
  )
  return { trades, executions, projects,
    nicknameMap: Object.fromEntries(nicknames.map(n => [n.account_number, n.nickname])),
    ...buildSetupTradeLog({ trades, executions, projects, userId }) }
}
